interface iPropsTotal {
    title: string,
    totalRegistros: string
}

export default function TotalRegistros({ title, totalRegistros }:iPropsTotal) {
    return (
        <div id="total_registros">
            <p className="total_title">{title}</p>
            <p className="titleMain">{totalRegistros}</p>
        </div>
    )
}